import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import(/* webpackChunkName: "home" */ '../views/Home')
    },
    {
        path: '/help',
        name: 'Help',
        component: () => import(/* webpackChunkName: "support" */ '../views/Help')
    },
    {
        path: '/cookie-policy',
        name: 'Cookies',
        component: () => import(/* webpackChunkName: "support" */ '../views/CookiePolicy')
    },
    {
        path: '/terms',
        name: 'Terms',
        component: () => import(/* webpackChunkName: "support" */ '../views/Terms')
    },
    {
        path: '/privacy',
        name: 'Privacy',
        component: () => import(/* webpackChunkName: "support" */ '../views/Privacy')
    },
    {
        path: '/setup',
        name: 'Setup',
        redirect: { name: 'SetupHome'},
        component: () => import(/* webpackChunkName: "setup" */ '../views/Setup'),
        children: [
            {
                path: 'home',
                name: 'SetupHome',
                components: {
                    default: () => import(/* webpackChunkName: "setup" */ '../views/setup/Home'),
                    steps: () => import(/* webpackChunkName: "setup" */ '../components/setup/Steps'),
                    nav: () => import(/* webpackChunkName: "setup" */ '../components/setup/Navigation'),
                },
                meta: {
                    requiresAddress: true,
                }
            },
            {
                path: 'current',
                name: 'SetupCurrent',
                components: {
                    default: () => import(/* webpackChunkName: "setup" */ '../views/setup/Current'),
                    steps: () => import(/* webpackChunkName: "setup" */ '../components/setup/Steps'),
                    nav: () => import(/* webpackChunkName: "setup" */ '../components/setup/Navigation'),
                },
                meta: {
                    requiresAddress: true,
                }
            },
            {
                path: 'energy',
                name: 'SetupEnergy',
                components: {
                    default: () => import(/* webpackChunkName: "setup" */ '../views/setup/Usage'),
                    steps: () => import(/* webpackChunkName: "setup" */ '../components/setup/Steps'),
                    nav: () => import(/* webpackChunkName: "setup" */ '../components/setup/Navigation'),
                },
                meta: {
                    requiresAddress: true,
                }
            },
            {
                path: 'deal',
                name: 'SetupDeal',
                components: {
                    steps: () => import(/* webpackChunkName: "setup" */ '../components/setup/Steps'),
                    default: () => import(/* webpackChunkName: "setup" */ '../views/setup/Deal')
                },
            },
            {
                path: 'debit',
                name: 'SetupDebit',
                components: {
                    default: () => import(/* webpackChunkName: "setup" */ '../views/setup/Debit')
                },
                meta: {
                    auth: true,
                    verified: true,
                }
            },
            {
                path: 'complete',
                name: 'SetupComplete',
                components: {
                    default: () => import(/* webpackChunkName: "setup" */ '../views/setup/Complete')
                },
                meta: {
                    auth: true,
                    verified: true,
                    directDebit: true,
                }
            },
        ]
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        components: {
            default: () => import(/* webpackChunkName: "profile" */ '../views/Dashboard')
        },
        meta: {
            auth: true,
            verified: true,
            directDebit: true,
        }
    },
    {
        path: '/profile',
        name: 'Profile',
        redirect: { name: 'ProfileSettings'},
        component: () => import(/* webpackChunkName: "profile" */ '../views/profile/Layout'),
        children: [
            {
                path: 'settings',
                name: 'ProfileSettings',
                component: () => import(/* webpackChunkName: "profile" */ '../views/profile/Settings'),
            },
            {
                path: 'rewards',
                name: 'ProfileRewards',
                component: () => import(/* webpackChunkName: "profile" */ '../views/profile/Rewards'),
            },
            {
                path: 'supply/:property',
                name: 'PropertySupplyUpdate',
                component: () => import(/* webpackChunkName: "profile" */ '../views/profile/SupplyUpdate'),
            },
            {
                path: 'usage/:property',
                name: 'PropertyUsageUpdate',
                component: () => import(/* webpackChunkName: "profile" */ '../views/profile/UsageUpdate'),
            },
        ],
        meta: {
            auth: true,
            verified: true,
            directDebit: true,
        }
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import(/* webpackChunkName: "auth" */ '../views/auth/Login.vue'),
    },
    {
        path: '/register',
        name: 'Register',
        component: () => import(/* webpackChunkName: "auth" */ '../views/auth/Register.vue'),
    },
    {
        path: '/register/done',
        name: 'RegisterDone',
        component: () => import(/* webpackChunkName: "auth" */ '../views/auth/RegisterDone.vue')
    },
    {
        path: '/password/reset',
        name: 'PasswordReset',
        component: () => import(/* webpackChunkName: "auth" */ '../views/auth/PasswordReset.vue')
    },
    {
        path: '/password/set/:code',
        name: 'PasswordSet',
        component: () => import(/* webpackChunkName: "auth" */ '../views/auth/PasswordSet.vue')
    },
    {
        path: '/verify/:token',
        name: 'Verify',
        component: () => import(/* webpackChunkName: "auth" */ '../views/auth/Verify.vue'),

    },
    {
        path: '/code/:code',
        name: 'ReferralLanding',
        component: () => import(/* webpackChunkName: "referral" */ '../views/ReferralLanding.vue'),

    },
    {
        path: '*',
        name: 'CatchAll',
        component: () => import(/* webpackChunkName: "notfound" */ '../views/errors/Error404')
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior () {
        return { x: 0, y: 0 }
    }
});

router.beforeEach((to, from, next) => {
        if (to.matched.some(record => record.meta.auth) && store.getters["auth/isGuest"]) {
            next({name: 'Login'})
        } else if(to.matched.some(record => record.meta.verified) && !store.getters["auth/isVerified"]) {
            next({ name: 'RegisterDone' })
        } else if(to.matched.some(record => record.meta.directDebit) && !store.getters["auth/hasDirectDebit"] && !store.getters["auth/isFresh"]) {
            next({ name: 'SetupDebit' })
        } else {
            next() // make sure to always call next()!
        }

})
router.afterEach((to) => {
    window.gtag && window.gtag('config', window.GA_TRACKING_ID, {
        page_path: to.fullPath,
        page_title: to.name,
        send_page_view: true,
    });

    window.gtag && window.gtag('event', 'screen_view', {
        screen_name: to.name,
    });
});
export default router
